 

<template>
    <v-card elevation="5" outlined shaped>
   

     
  
   
  
      <div>
        <v-alert dense color="#EE680B" style="color: #ffffff">
          <h5>BIBLIOTECA VIRTUAL</h5>
        </v-alert>
      </div>
      <div>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
            
            
              
              <v-col cols="12" md="12">
                <v-img
                :src="'http://74.50.72.10:3009/uploads/estudiantes/BIBLIOTECA.jpg'"
                style="width: 100%; display: block;
                                   
                                    margin: 1vh auto;"
              ></v-img>
              </v-col>
   
              
              <v-col cols="12" md="12">
              
                    <v-btn 
             rounded
                   color="#002245"
                    class="ma-2 white--text"
                     @click="showmoodle()"
                    >
                  GESTOR DE BIBLIOTECA
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-book-search-outline
              </v-icon>
           </v-btn>
              
              </v-col>
              
   
      
              <v-col cols="12" md="12">
                
                  <!--v-toolbar-title style="color: #ffffff">
                    <h6>ACCEDE A NUESTRA BIBLIOTECA VIRTUAL HACIENDO CLICK EN EL BOTON NARANJA ..>>>></h6>
                  </v-toolbar-title-->
  
                  <!--v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    color="#EE680B"
                     @click="showmoodle1()"
                    
                    style="float: left"
                    title="BIBLIOTECA VIRTUAL"
                  >
                    <v-icon dark> mdi-gesture-double-tap </v-icon>
                  </v-btn-->
                  <v-btn 
             rounded
                   color="#EE680B"
                    class="ma-2 white--text"
                     @click="showmoodle1()"
                    >
                  BIBLIOTECA VIRTUAL
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-book-search-outline
              </v-icon>
           </v-btn>
                
               
              </v-col>
           
  
            
  
             
  
         
            </v-row>
          </v-container>
        </v-form>
      </div>
 
  
  
      <div class="text-center">
        <v-snackbar
          v-model="snackbarOK"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbar }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarOK = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
      <div class="text-center">
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbar }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
  
      <div class="text-center">
        <v-snackbar
          v-model="snackbarError1"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarHorario }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError1 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
      <div class="text-center">
        <v-snackbar
          v-model="snackbarError2"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarGrupoLleno }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError2 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
  
        <v-snackbar
          v-model="snackbarError3"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarNivel }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError3 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError4"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarQuitarMateriaNivel }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError4 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError5"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarDocumentos }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError5 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError6"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarFechaInscripcion }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError6 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError7"
          :timeout="timeout"
          top
          right
          shaped
          dense
          color="#EE680B"
          outlined
        >
          <strong>{{ mensajeSnackbarCantidadMaximaMaterias }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError7 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
    </v-card>
  </template>
  <script>
  import axios from "axios";
  import VueHtml2pdf from "vue-html2pdf";
  
  //import pdfMake from "pdfmake/build/pdfmake";
  //import pdfFonts from "pdfmake/build/vfs_fonts";
  //pdfMake.vfs = pdfFonts.pdfMake.vfs;
  export default {
    data() {
      return {
        datosTotalesHistorialEconomico:[],
        totalMaterias: 0,
        paraleloTeorico: "",
        urlFoto: "",
        showUrl: true,
        showUrl2: true,
        urlFotoData: [],
        imagePre: 0,
  
        gradoAcademico: "",
        datosPromedioGestiones: [],
        matricula: "",
        datosDocumentosPendientes: [],
        contadorGestiones: 0,
        datosKardexGestion: [],
        imprimirPaginacion: 0,
        materiasReprobadas: 0,
        sumatoriaNotasFinales: 0,
        promedioMateriasAprobadas: 0,
        materiasAprobadas: 0,
        materiasTomadas: 0,
        totalHorasAcademicasVencidas: 0,
  
        segundos: "",
        minutos: "",
        hora: "",
        imprimirHora: "",
        today: "",
        imprimirFecha: "",
        searchpostexp:"",
        dia: "",
        mes: "",
        año: "",
        searchciudad:"",
  
        fechaInscripcionIni: "",
        fechaInscripcionFin: "",
        datosFechaInscripcion: [],
        datosRecursado: "",
        recursada: "N",
        hoy: "",
        hoy1: "",
        fechaEntrega: "",
        tipoInscripcion: "WEBADM",
        mat: "",
        pat: "",
        id_estudiante: "",
        unicodigo: "",
        num_documento: "",
        paterno: "",
        materno: "",
        nombres: "",
        nombreCompleto: "",
        datosCarrera: [],
        idPlanestudio: "",
        idCarrera: "",
        carrera: "",
        gestion: "",
        idGestion: "",
        datosHistorial: [],
        datosHistorialobs: [],
        searchtpost:"",
        searchsede:"",
        idMateria: "",
        detalleModal: 0,
        datosCantidadEstGrupo: [],
        datosGruposInscripcion: [],
        idTurno: "",
        datosTurno: [],
        datospagobsGestion:[],
        turno: "",
        idGrupoDocente: "",
        idTipoModalidad: 1,
        modalidad: "",
        paralelo: "",
        capacidad: "",
        tipoGrupo: "",
        idNivel: "",
        idUsuario: 6,
        idPlanEconomico: 115,
        yaInscrito: false,
        cantidadMaximaMaterias: 6,
        //maxMateriasPreinscritas: 0,
        cantidadActualMaterias: 0,
        datosGruposPreInscripcion: [],
        idNota: "",
        minimoNivel: "",
        datosOfertaMateriasNivel: [],
        idGrupoAux: "",
  
        //tipo: "PRACTICO",
        gruposPracticosModal: 0,
  
        horarioModal: 0,
        datosHorario: [],
        idFranjaHoraria: "",
        idDia: "",
        cantAct: "",
        datosCantidadEspacio: [],
        datosHorariosGrupo: [],
        datosFranjaHoraria: [],
        //datosHorarioConvertido: [LUNES, MARTES, MIERCOLES, JUEVES, VIERNES, SABADO, DOMINGO],
        tienePractico: "FALSE",
  
        choqueHorario: 0,
        idGrupoPadre: "",
        esCompartido: "",
        kardexModal: 0,
        datosDocumentos: [],
        choquecant: 0,
        search: "",
        searchistorialeco:"",
        inpNum: "",
        id_docente: "",
        tipodocente: "",
        searchDocente: "",
        selectGenero: "",
        datosGenero: ["FEMENINO", "MASCULINO"],
        auxmat: "",
        auxpat: "",
        uniest: "",
        checkboxExppost: false,
        datosOfertaCorregido: [],
        datosCantMateriasEst: [],
        datosEstudiante: [],
        datosGestion: [],
        datosKardex: [],
        datosGruposInscripcionPracticos: [],
        est: "",
        elModal: 0,
        carreraModal: 0,
        gestionModal: 0,
        turnoModal: 0,
        horarioModal1: 0,
        documentosModal: 0,
        datosNivelesPreinscritos: [],
        nivelMaximoPreInscrito: "",
        datostpost: [],
        tpost:"",
  
    headerstpost: [
      { text: "CATEGORIA", value: "categoria", sortable: true },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
        itencant: 0,
        doble: 0,
        itemcantidadModal: 0,
        deleteDialog: 0,
        oldNum: "",
        iditemdet: "",
        iditemdet1: "",
        totaldet: "",
        searchpais:"",
        idtrans: "",
        busest: "",
        matricula:"",
        idcategoriaest: "",
        categoriaest: "",
        tiponacional: "",
        paisest: "",
        sedeModal: 0,
        tpostModal: 0,
        snackbarOK: false,
        nuevadireccionpost:"",
        mensajeSnackbar: "",
        mensajeSnackbarGrupoLleno: "GRUPO LLENO",
        mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
        mensajeSnackbarHorario: "CHOQUE DE HORARIO",
        mensajeSnackbarCantidadMaximaMaterias:
          "CANTIDAD MAXIMA DE MATERIAS TOMADAS",
        mensajeSnackbarQuitarMateriaNivel:
          "PRIMERO QUITE MATERIAS DE NIVEL SUPERIOR",
        mensajeSnackbarDocumentos: "REGULARICE SU DOCUMENTACIÓN",
        mensajeSnackbarFechaInscripcion: "FUERA DE FECHA DE INSCRIPCIONES",
        snackbarError: false,
        snackbarError1: false,
        snackbarError2: false,
        snackbarError3: false,
        snackbarError4: false,
        snackbarError5: false,
        snackbarError6: false,
        snackbarError7: false,
        mensajeError: "",
  
        timeout: 2000,
  
        alert: { show: false, message: "" },
        alertdocumento: { show: false, message: "" },
  
        headersTurno: [
          { text: "TURNO", value: "turno", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersHorario: [
          { text: "HORA", value: "hr", sortable: true },
          { text: "LUNES", value: "docaumat", sortable: true },
          { text: "MARTES", value: "docaumat", sortable: true },
          { text: "MIERCOLES", value: "docaumat", sortable: true },
          { text: "JUEVES", value: "docaumat", sortable: true },
          { text: "VIERNES", value: "docaumat", sortable: true },
          { text: "SABADO", value: "docaumat", sortable: true },
          // { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersDocumentos: [
          { text: "DOCUMENTO", value: "documento", sortable: true },
          { text: "FECHA", value: "fpl", sortable: true },
          { text: "ESTADO", value: "estado", sortable: true },
          // { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersFranjaHoraria: [
          { text: "HORA", value: "hr", sortable: true },
          { text: "LUNES", value: "lu", sortable: true },
          { text: "MARTES", value: "ma", sortable: true },
          { text: "MIERCOLES", value: "mi", sortable: true },
          { text: "JUEVES", value: "ju", sortable: true },
          { text: "VIERNES", value: "vi", sortable: true },
          { text: "SABADO", value: "sa", sortable: true },
          { text: "DOMINGO", value: "do", sortable: true },
        ],
        headersCarrera: [
          { text: "CARRERA", value: "carre", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersCantidadEstGrupo: [
          { text: "GRUPO", value: "idgru", sortable: true },
          { text: "PATERNO", value: "pat", sortable: true },
          { text: "MATERNO", value: "mat", sortable: true },
          { text: "NOMBRE", value: "nomb", sortable: true },
          { text: "ESTUDIANTES INSCRITOS", value: "cant", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersGrupoInscripcion: [
          { text: "GRUPO", value: "gru", sortable: true },
          { text: "DOCENTE", value: "doce", sortable: true },
          { text: "NIVEL", value: "idnv", sortable: true },
          { text: "CUPO", value: "cup", sortable: true },
          { text: "MODALIDAD", value: "modalidad", sortable: true },
          { text: "TURNO", value: "tu", sortable: true },
          { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
          //{ text: "ESTADO", value: "est", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersGrupoInscripcionPracticos: [
          { text: "GRUPO", value: "gru", sortable: true },
          { text: "DOCENTE", value: "doce", sortable: true },
          { text: "NIVEL", value: "idnv", sortable: true },
          { text: "CUPO", value: "cup", sortable: true },
          { text: "MODALIDAD", value: "modalidad", sortable: true },
          { text: "TURNO", value: "tu", sortable: true },
          { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
          //{ text: "ESTADO", value: "est", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersGrupoPreInscripcion: [
          { text: "PARALELO", value: "gru", sortable: true },
          { text: "MATERIA", value: "mate", sortable: true },
          { text: "DOCENTE", value: "doce", sortable: true },
          { text: "NIVEL", value: "idnv", sortable: true },
          //{ text: "CUPO", value: "cup", sortable: true },
          { text: "MODALIDAD", value: "modalidad", sortable: true },
          { text: "TURNO", value: "tu", sortable: true },
          { text: "TIPO DE GRUPO", value: "tpgru", sortable: true },
          //{ text: "ESTADO", value: "est", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersHistorial: [
          { text: "GESTION", value: "nomges", sortable: true },          
          { text: "ITEM", value: "nomits", sortable: true },
          { text: "FECHA DE PAGO", value: "fec", sortable: true },         
          { text: "FACTURA", value: "factura", sortable: true },
          { text: "MONTO(Bs)", value: "monto", sortable: true },                  
          //{ text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersGestion: [
          { text: "GESTION", value: "nom", sortable: true },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersEstudiante: [
          { text: "UNICODIGO", value: "unicod", sortable: true },
  
          { text: "PATERNO", value: "pat", sortable: false },
          { text: "MATERNO", value: "mat", sortable: false },
          { text: "NOMBRES", value: "nom", sortable: false },
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
        headersKardex: [
          { text: "GESTION", value: "gest", sortable: true },
          { text: "CRED", value: "cred", sortable: true },
          { text: "MATERIA", value: "mate", sortable: true },
          { text: "GRUPO",value: "paralel", sortable: true },
          { text: "1P", value: "p1", sortable: true },
          { text: "2P", value: "p2", sortable: false },
          { text: "3P", value: "p3", sortable: true },
          { text: "ASIS", value: "asis", sortable: true },
          { text: "EX FINAL", value: "exfin", sortable: false },
          { text: "2DA INST", value: "seginst", sortable: true },
          { text: "MESA", value: "mesa", sortable: false },
          { text: "GRACIA", value: "graci", sortable: true },
          { text: "NOTA FINAL", value: "notafin", sortable: true },
          { text: "ESTADO", value: "estado", sortable: false },
          { text: "OBSERVACIONES", value: "observac", sortable: true },
        ],
        headerspostexp: [
      { text: "CIUDAD", value: "ciudad", sortable: false },
      { text: "SIGLA", value: "ciudadabre", sortable: false },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
        headerssede: [
              { text: "SEDE", value: "sede", sortable: false },
              { text: "OPCIONES", value: "actions", sortable: false },
          ],
  
        user: {},
        usuario: "",
        id_sede: "",
        nomus: "",
        patus: "",
        matus: "",
        id_documento: "",
        datosTipoDocumento: "",
  
        id_tipo_documento: "",
        tipo_doc_nom: "",
        iddocseg2: "",
        documento2: "",
        nivelMinimo: "",
  
        select: "",
        selectAño: "",
        selectCiudad: "",
        selectPais: "",
        tituloObtenido: "",
        institucion: "",
        areaEstudios: null,
        añoObtencion: "",
        cargaHoraria: null,
        datosPais: [],
        url:"",
        datosciudad: [],
        tpFormacion: "",
        datosFormacionAcademica: [],
        selectPais1: "",
        act: 0,
        idForm: "",
        botonAct: 0,
        numeroPag:0,
        flag: 1,
        datosObservacion:[],
        items: ["MASCULINO", "FEMENINO"],
    tiponacionalidad: ["BOLIVIANA", "EXTRANJERO"],
    tipo_doc: ["CI", "PASAPORTE","DNI"],
    estado_civil: ["CASADO(A)", "SOLTERO(A)", "VIUDO(A)", "DIVORCIADO(A)"],
        tipodocpost:"",
        generopost:"",
        fechanacipost:"",
        datospostexp:[],
        estadocivpost:"",
        direccionpost:"",
        emailpost:"",
        telefonopost:"",
        menuIni: 0,
        cole:"",
        egresopost:"",
        paispost:"",
        postexp:"", 
        postexpModal: 0,
        id_pais:"",
        egresoModal: 0,
    searchegreso: "",
    datosegreso: [],
    headersegreso: [
      { text: "AÑO EGRESO", value: "anoegreso", sortable: true },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
        colegioModal: 0,
    searchcolegio: "",
    datosColegio: [],
  
    headersColegio: [
      { text: "COLEGIO", value: "cole", sortable: false },
      { text: "DISTRITO", value: "distri", sortable: false },
      { text: "TURNO", value: "tu", sortable: false },
      { text: "TIPO COLEGIO", value: "tpcol", sortable: false },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
    paisModal: 0,
    datospais: [],
    ciudadModal: 0,
    searchpais: "",
    headerspais: [
      { text: "PAIS", value: "pais", sortable: false },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
    headersciudad: [
      { text: "CIUDAD", value: "ciudad", sortable: false },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
      };
    },
    created: function () {
      this.user = JSON.parse(sessionStorage.getItem("session"));
      this.usuario = this.user.personal;
      this.id_sede = this.user.id_sede;
      this.sede = this.user.sede;
      this.nomus =
        this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
        this.listarlinkmoodle(this.sede);
    },
    computed: {},
    components: {
      VueHtml2pdf,
    },
  
    methods: {
      quitarNulosTotales(){
        for (let i = 0; i < this.datosTotalesHistorialEconomico.length; i++) {
          Object.keys(this.datosTotalesHistorialEconomico[i]).forEach((key) => {
            if (this.datosTotalesHistorialEconomico[i][key] === null) {
              this.datosTotalesHistorialEconomico[i][key] = 0;
            }
          });
        
        }
      },
      async listarlinkmoodle(id_sede) {
        let me = this;
        await axios
          .get(
            "/estudiante/listaraccmoodle/" +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosEstudiante = [];
             // me.limpiarApell();
             // me.snackbarOK = true;
             // me.mensajeSnackbar = response.data.message;
            } else {
              me.datosEstudiante = response.data.resultado;
              me.url = me.datosEstudiante[0].acces;

             // me.limpiarApell();
            }
          })
          .catch(function (error) {});
      },
      showmoodle() {
      
      //window.open(this.url, '_blank');
      window.open('http://190.181.15.155:8081', '_blank');
     
     },
     showmoodle1() {
      
      //window.open(this.url, '_blank');
      window.open('http://200.105.156.214:8081', '_blank');
     
     },
      async listarTotalesHistorial() {
        let me = this;
        await axios
          .get(
            "/estudiante/listarTotalesHistorialEconomico33/" +
              this.unicodigo +
              "," +
              this.id_sede+
              "," +
              this.idPlanestudio
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosTotalesHistorialEconomico = [];
            } else {
              me.datosTotalesHistorialEconomico = response.data.resultado;
              me.quitarNulosTotales();
            }
          })
          .catch(function (error) {});
      },
      quitarNulos(){
        for (let i = 0; i < this.datosHistorial.length; i++) {
  
        Object.keys(this.datosHistorial[i]).forEach((key) => {
        if (this.datosHistorial[i][key] === null) {
          this.datosHistorial[i][key] = 0;
          }
        });
          this.totalPagado=this.totalPagado +this.datosHistorial[i].monto;
          this.totalDescuento= this.totalDescuento+this.datosHistorial[i].descuen;
          this.totalDeuda=this.totalDeuda+this.datosHistorial[i].deud;
  
  
        }
      },
      cargarTamaño() {
        this.tamaño = this.datosKardexGestion.length;
      },
      async listarObservacionGestion() {
          let me = this;
          await axios
            .get(
              "/estudiante/observacionGestion/" +
                this.unicodigo +
                "," +
                this.id_sede 
            )
            .then(function (response) {
              if (response.data.resultado == null) {
                me.datosObservacion = [];
              } else {
                me.datosObservacion = response.data.resultado;
              }
            })
            .catch(function (error) {});
        },
      imprimirKardex1() {
        
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
          CourierPrime: {
            normal: "Courier Prime.ttf",
            bold: "Courier Prime Bold.ttf",
            italics: "Courier Prime Italic.ttf",
            bolditalics: "Courier Prime Bold Italic.ttf",
          },
        };
      const cantidadHojas = this.datosKardexGestion.length;
         
        const content = [];
        for (let i = 0; i < cantidadHojas; i++) {
              
            
  
            const item = {
              Ncontrato: [{ text: `\n\n\n ${this.imprimirFecha}\n\n\n` }],
              titulo: [{ text: `\nKARDEX DE ESTUDIANTE\n\n\n\n` }],
              datosPer: {
                widths: ["52%", "12%", "12%", "12%", "12%"],
                body: [], // Inicialmente, la tabla está vacía
              },
              primera: [
                { text: "PRIMERA (Partes).-", bold: true },
                { text: " Son parte de este contrato: \n\n" },
                { text: "1.1.", bold: true },
                " La ",
                { text: "Universidad Central (UNICEN),", bold: true },
                " con personalidad jurídica aprobada mediante Resolución Suprema N° 208442, con domicilio legal en la calle Santivañez N° 240, con NIT N°1009389020, representada por su ",
                {
                  text: "RECTOR, ING. JOSE MIGUEL BUSTAMANTE AMAYA,",
                  bold: true,
                },
                "con C.I. N° 3347898 LP., que en lo posterior se denominará simplemente: ",
                { text: "UNICEN. \n\n", bold: true },
  
                { text: "1.2.", bold: true },
                
                { text: " El Profesional.\n\n", bold: true },
              ],
            
  
              tabla: {
                widths: ["52%", "12%", "12%", "12%", "12%"],
                body: [], // Inicialmente, la tabla está vacía
              },
           
            
            };
            item.tabla.body.unshift([
              { text: "MATERIAS (GRUPO)", alignment: "center", bold: true },
              { text: "FECHA INICIO", bold: true },
              { text: "FECHA FINAL", bold: true },
              { text: "TOTAL HRS MATERIA", bold: true },
              { text: "MONTO", bold: true },
            ]);
  
              
  
            for (let j = 0; j < this.datosKardexGestion.length; j++) {
              
              if(this.datosKardexGestion[i].idges==this.datosKardex[j].idges)
  
              { 
                           
              
              item.tabla.body.push([
                { text: `${this.datosKardex[j].matnom}`, alignment: "center" },
                ` ${this.datosKardex[j].p1}`,
                ` ${this.datosKardex[j].p2}`,
                ` ${this.datosKardex[j].p3}`,
                ` ${this.datosKardex[j].exfin}`,
              ]);
             
              }
            }
           
          
            
            content.push(
              { text: item.Ncontrato, style: "contrato" },
              { text: item.titulo, style: "header" },
              { text: item.text, style: "conte" },
              { text: item.primera, style: "conte" },
              { table: item.tabla, style: "conteTabla" },       
            
             
            );
            if (i < cantidadHojas) {
              content.push({ text: "", pageBreak: "before" });
            }
        }
          const styles = {
            contrato: {
              fontSize: 10,
              alignment: "right",
              bold: true,
            },
            header: {
              fontSize: 15,
              alignment: "center",
              bold: true,
            },
            conte: {
              fontSize: 10,
              alignment: "justify",
            },
           
           
            conteTabla: {
              fontSize: 8,
              alignment: "center",
            },
          };
          const docDefinition = {
            content: content,
            styles: styles,
            defaultStyle: {
              font: "CourierPrime",
            },
           /*  pageSize: 'LEGAL', */
          };
          const pdfDocGenerator = pdfMake.createPdf(docDefinition);
          pdfDocGenerator.open();
  
       
       
      },
     
      async listarKardexGestion() {
        let me = this;
        await axios
          .get(
            "/estudiante/kardexGestion/" +
              this.unicodigo +
              "," +
              this.idCarrera +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosKardexGestion = [];
            } else {
              me.datosKardexGestion = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarpagobsGestion() {
        let me = this;
        await axios
          .get(
            "/estudiante/pagosobsGestionest/" +
              this.unicodigo +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datospagobsGestion = [];
            } else {
              me.datospagobsGestion = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      fechaReporte() {
        this.today = new Date();
        this.dia = this.today.getDate();
        this.mes = this.today.getMonth() + 1;
        this.año = this.today.getFullYear();
        this.hora = this.today.getHours();
        this.minutos = this.today.getMinutes();
        this.segundos = this.today.getSeconds();
        this.imprimirFecha = this.dia + "-" + this.mes + "-" + this.año;
  
        this.imprimirHora = this.hora + ":" + this.minutos + ":" + this.segundos;
      },
      beforeDownload({ html2pdf, options, pdfContent }) {
        html2pdf()
  
          .set(options, { margin: 0.47, image: { type: 'jpeg', quality: 2 }, html2canvas: { scale: 2 }, jsPDF: { unit: 'in', format: 'legal', orientation: 'portrait' } })
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            this.numeroPag = pdf.internal.getNumberOfPages();
  
  
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              var imgData = ' data:image/jpeg;base64,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';
              // arreglar para q se imprima en cada hoja el logotipo
              pdf.addImage(imgData, 'JPEG', 10, 10, 50, 50);
              pdf.setFontSize(8);
              pdf.setTextColor(100);
              pdf.text(
                "Página " + i + " / " + totalPages,
                pdf.internal.pageSize.getWidth() * 0.86,
                pdf.internal.pageSize.getHeight() - 13.60
              );
  
            }
          })
          .save();
      },
      encontrarNivelAltoGrupoPreinscritos() {
        for (let i = 0; i < this.datosGruposPreInscripcion.length; i++) {
          this.datosNivelesPreinscritos.push(
            this.datosGruposPreInscripcion[i].idnv
          );
        }
        this.nivelMaximoPreInscrito = Math.max.apply(
          null,
          this.datosNivelesPreinscritos
        );
  
        if (this.idNivel == this.nivelMaximoPreInscrito) {
          this.verificarQuitarMateria();
        } else {
    
          this.snackbarError4 = true;
        }
  
  
        this.datosNivelesPreinscritos = [];
      },
  
      verificarDocumentos() {
        this.hoy = new Date();
  
        for (let i = 0; i < this.datosDocumentos.length; i++) {
          this.fechaEntrega = new Date(this.datosDocumentos[i].fpl);
  
          if (this.datosDocumentos[i].estado == "PENDIENTE") {
            if (this.hoy.getTime() <= this.fechaEntrega.getTime()) {
              this.verificarTipoGrupo();
            } else {
              this.showDocumento();
              this.snackbarError5 = true;
            }
          } else {
            this.verificarTipoGrupo();
          }
        }
      },
    
      imprimirHorario() {
        const html2PdfComponent = this.$refs.horario;
        html2PdfComponent.generatePdf();
      },
      getFilaColor(index) {
        const colors = ["lightgray", "white"]; // Define los colores que deseas utilizar
  
        // Asigna un color diferente a cada fila basado en el índice de iteración
        const colorIndex = index % colors.length;
        const color = colors[colorIndex];
  
        return {
          backgroundColor: color,
        };
      },
  
      remplazoBrPorLinea(text) {
        return text.replace(/<br>/g, "\n");
      },
      limpiarApell() {
        this.pat = "";
        this.mat = "";
        this.uniest = "";
      },
      aumentarEspacios() {
        if (this.pat != "" && this.mat == "") {
          this.mat = " ";
        } else {
          if (this.pat == "" && this.mat != "") {
            this.pat = " ";
          } else {
          }
        }
      },
      extraerCantMateriasTomadasEst() {
        this.cantidadActualMaterias = this.datosCantMateriasEst[0].cantmat;
      
      },
  
      getColor(insc) {
        if (insc == "LIBRE") return "green";
        else return "#868582";
      },
      getColorKardex(insc) {
        if (insc == "APROBADO") return "green";
        else return "#e93a0b";
      },
      getColorNotaFinal(insc) {
        if (insc >= 51) return "#3E9732";
        else return "#e93a0b";
      },
      getColorGrupos(insc) {
        if (insc == "TEORICO") return "light-blue accent-2";
        else return "orange accent-2";
      },
      async listarTurno() {
        let me = this;
        await axios
          .get(
            "/estudiante/listarTurnoIns/" +
              this.idGestion +
              "," +
              this.idPlanestudio +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosTurno = [];
            } else {
              me.datosTurno = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
  
      async listarDocumento(unicodigo) {
        let me = this;
        await axios
          .get("/estudiante/buscadepen/" + this.unicodigo)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosDocumentos = [];
              me.verificarTipoGrupo();
            } else {
              me.datosDocumentos = response.data.resultado;
              me.verificarDocumentos();
            }
          })
          .catch(function (error) {});
      },
  
     
  
      async listarFranjaHoraria(unicodigo) {
        let me = this;
        await axios
          .get("/estudiante/listarFranjaHorariaEstCompartido/" + this.unicodigo +
              "," +
              this.id_sede)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosFranjaHoraria = [];
            } else {
              me.datosFranjaHoraria = response.data.resultado;
              me.datosFranjaHoraria.forEach(function (dato) {
                let dd = "";
                dato.lu = dd;
                dato.ma = dd;
                dato.mi = dd;
                dato.ju = dd;
                dato.vi = dd;
                dato.sa = dd;
                dato.do = dd;
              });
              for (let i = 0; i < me.datosFranjaHoraria.length; i++) {
                for (let j = 0; j < me.datosHorario.length; j++) {
                  if (
                    me.datosFranjaHoraria[i].idfh == me.datosHorario[j].idfranja
                  ) {
                    switch (me.datosHorario[j].dias) {
                      case "LUNES":
                        me.datosFranjaHoraria[i].lu = me.datosHorario[j].docaumat;
                        break;
                      case "MARTES":
                        me.datosFranjaHoraria[i].ma = me.datosHorario[j].docaumat;
                        break;
                      case "MIERCOLES":
                        me.datosFranjaHoraria[i].mi = me.datosHorario[j].docaumat;
                        break;
                      case "JUEVES":
                        me.datosFranjaHoraria[i].ju = me.datosHorario[j].docaumat;
                        break;
                      case "VIERNES":
                        me.datosFranjaHoraria[i].vi = me.datosHorario[j].docaumat;
                        break;
                      case "SABADO":
                        me.datosFranjaHoraria[i].sa = me.datosHorario[j].docaumat;
                        break;
                      case "DOMINGO":
                        me.datosFranjaHoraria[i].do = me.datosHorario[j].docaumat;
                        break;
                      default:
                    }
                  }
                }
              }
            } //else
          })
          .catch(function (error) {});
      },
      async listarHorario(unicodigo, idGestion, idPlanestudio) {
        let me = this;
        await axios
          .get(
            "/estudiante/listarHorarioEstudiante/" +
              this.unicodigo +
              "," +
              this.idGestion +
              "," +
              this.idPlanestudio+
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosHorario = [];
            } else {
              me.datosHorario = response.data.resultado;
  
              me.listarFranjaHoraria(me.unicodigo);
            }
          })
          .catch(function (error) {});
      },
  
      async listarGruposInscripcion(
        idPlanestudio,
        idMateria,
        id_sede,
        idGestion,
        idTurno,
        idTipoModalidad
      ) {
        let me = this;
        await axios
          .get(
            "/estudiante/gruposInscripcion/" +
              this.idPlanestudio +
              "," +
              this.idMateria +
              "," +
              this.id_sede +
              "," +
              this.idGestion +
              "," +
              this.idTurno +
              "," +
              this.idTipoModalidad
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosGruposInscripcion = [];
            } else {
              me.datosGruposInscripcion = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarGruposInscripcionPractica(
        idPlanestudio,
        idMateria,
        id_sede,
        idGestion,
        idTurno,
        idTipoModalidad
      ) {
        let me = this;
        await axios
          .get(
            "/estudiante/gruposInscripcionPractico/" +
              this.idPlanestudio +
              "," +
              this.idMateria +
              "," +
              this.id_sede +
              "," +
              this.idGestion +
              "," +
              this.idTurno +
              "," +
              this.idTipoModalidad+
              "," +
              this.paraleloTeorico
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosGruposInscripcionPracticos = [];
            } else {
              me.datosGruposInscripcionPracticos = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarGruposPreInscripcion(
        idPlanestudio,
        id_sede,
        idGestion,
        idTurno,
        idTipoModalidad,
        unicodigo
      ) {
        let me = this;
        await axios
          .get(
            "/estudiante/gruposPreinscritos/" +
              this.idPlanestudio +
              "," +
              this.id_sede +
              "," +
              this.idGestion +
              "," +
              this.idTurno +
              "," +
              this.idTipoModalidad +
              "," +
              this.unicodigo
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosGruposPreInscripcion = [];
            } else {
              me.datosGruposPreInscripcion = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarCarrera(unicodigo) {
        let me = this;
        await axios
          .get(
            "/estudiante/listarcarreraestu/" + this.unicodigo + "," + this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosCarrera = [];
            } else {
              me.datosCarrera = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarGestion() {
        let me = this;
        await axios
          .get("/estudiante/buscagestionactualinscr/")
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosGestion = [];
            } else {
              me.datosGestion = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      llenarPromediosKardex() {
        this.materiasTomadas = this.datosKardex[this.datosKardex.length - 1].col;
  
        for (let i = 0; i < this.datosKardex.length; i++) {
          // this.promedioMateriasAprobadas =
          //this.promedioMateriasAprobadas + this.datosKardex[i].notafin;
  
          if (this.datosKardex[i].estado == "APROBADO") {
            this.materiasAprobadas = this.materiasAprobadas + 1;
            this.sumatoriaNotasFinales =
              this.sumatoriaNotasFinales + this.datosKardex[i].notafin;
            this.totalHorasAcademicasVencidas =
              this.totalHorasAcademicasVencidas + this.datosKardex[i].totalh;
          } else {
            this.materiasReprobadas = this.materiasReprobadas + 1;
          }
        }
        //this.materiasReprobadas = this.materiasAprobadas - this.materiasTomadas  ;
        this.promedioMateriasAprobadas = Math.round(
          this.sumatoriaNotasFinales / this.materiasAprobadas
        );
        this.totalMaterias = this.datosKardex.length;
      },
      limpiarTotales(){
      this.materiasTomadas=0;
        this.materiasAprobadas=0;
        this.materiasReprobadas=0;
        this.promedioMateriasAprobadas=0;
        this.totalHorasAcademicasVencidas=0;
        this.sumatoriaNotasFinales=0;
      },
      async listarKardex() {
  this.limpiarTotales();
        let me = this;
        await axios
          .get(
            "/estudiante/kardex/" +
              this.unicodigo +
              "," +
              this.idPlanestudio +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosKardex = [];
            } else {
              me.datosKardex = response.data.resultado;
              me.llenarPromediosKardex();
              me.listarKardexGestion();
              me.listarpagobsGestion();
              
            }
          })
          .catch(function (error) {});
      },
      async listarCantidadMateriasPreinsEstu(unicodigo, idGestion) {
        let me = this;
        await axios
          .get(
            "/estudiante/cantmateriasinscest/" +
              this.unicodigo +
              "," +
              this.idGestion
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosCantMateriasEst = [];
            } else {
              me.datosCantMateriasEst = response.data.resultado;
       
              me.extraerCantMateriasTomadasEst();
            }
          })
          .catch(function (error) {});
      },
      async listarHistorialEconomico(unicodigo, id_sede) {
        let me = this;
        await axios
          .get(
            "/estudiante/listarpagosest33/" +
              this.unicodigo +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosHistorial = [];
            } else {
              me.datosHistorial = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarHistorialEconomicobservaciones(unicodigo, id_sede,idPlanestudio) {
        let me = this;
        await axios
          .get(
            "/estudiante/pagosobsest/" +
              this.unicodigo +
              "," +
              this.id_sede
              +","+
              this.idPlanestudio
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosHistorialobs = [];
            } else {
              me.datosHistorialobs = response.data.resultado;
            }
          })
          .catch(function (error) {});
      },
      async listarHorarioGrupoPrivado(idGrupoDocente) {
        let me = this;
        await axios
          .get("/estudiante/listarHorarioGrupo/" + this.idGrupoDocente)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosHorariosGrupo = [];
            } else {
              me.datosHorariosGrupo = response.data.resultado;
  
              me.compararHorarios();
            }
          })
          .catch(function (error) {});
      },
      async listarHorarioGrupoCompartido(idGrupoPadre) {
        let me = this;
        await axios
          .get("/estudiante/listarHorarioGrupo/" + this.idGrupoPadre)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosHorariosGrupo = [];
            } else {
              me.datosHorariosGrupo = response.data.resultado;
  
              me.compararHorarios();
            }
          })
          .catch(function (error) {});
      },
  
      imprimirKardex() {
        
        this.listarDocumentoPendiente();
        const html2PdfComponent = this.$refs.kardex;
       
        html2PdfComponent.generatePdf();
      },
  
      imprimirKardexeco() {
        //this.listarDocumentoPendiente();
        const html2PdfComponent = this.$refs.kardexeconomico;
        html2PdfComponent.generatePdf();
      },
  
      validate() {
        this.$refs.form.validate();
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      change(event) {
        let val = event.target.value.trim();
        // Solo puede ser un entero positivo o vacío, el regular se puede modificar según las necesidades
        //item = e.target.value.replace(/[^\d]/g,'')
        if (/^[1-9]\d*$|^$/.test(val)) {
          this.oldNum = val;
        } else {
          event.target.value = this.oldNum;
        }
      },
  
      buscarEstudiante() {
        //this.aumentarEspacios();
        if (this.uniest != "") {
          this.listarEstudianteUnicod(this.uniest, this.id_sede);
        } else {
          this.listarEstudiante(this.pat, this.mat, this.id_sede);
        }
      },
  
      async listarEstudiante(pat, mat, id_sede) {
        if (this.pat == "") {
          this.auxpat = "XXX";
        } else {
          this.auxpat = this.pat;
        }
        if (this.mat == "") {
          this.auxmat = "XXX";
        } else {
          this.auxmat = this.mat;
        }
        let me = this;
        await axios
          .get(
            "/estudiante/buscarestapell/" +
              this.auxpat +
              "," +
              this.auxmat +
              "," +
              this.id_sede
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosEstudiante = [];
              me.limpiarApell();
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
            } else {
              me.datosEstudiante = response.data.resultado;
              me.limpiarApell();
            }
          })
          .catch(function (error) {});
      },
      
      seleccionarEstudiante(item) {
        this.sumatoriaNotasFinales = 0;
        this.materiasTomadas = 0;
        this.materiasAprobadas = 0;
        this.materiasReprobadas = 0;
        this.promedioMateriasAprobadas = 0;
        this.totalHorasAcademicasVencidas = 0;
        this.totalMaterias = 0;
        this.id_estudiante = item.idest;
        this.unicodigo = item.unicod;
        this.paterno = item.pat;
        this.materno = item.mat;
        this.nombres = item.nom;
        this.documento = item.numdoc;
        this.nombreCompleto = item.nom + " " + item.pat + " " + item.mat;
        this.urlFoto = item.urlimage;
        this.id_tpost = item.catest;
        this.tpost = item.testu;
        this.matricula = item.matr;
        this.generopost=item.sexoest;
        //console.log(item.sexoest);
        this.emailpost=item.mail;
        //console.log(item.mail);
        this.tipodocpost=item.tipodoc;
        this.telefonopost=item.tel;
        this.fechanacipost=item.fechest;
        this.estadocivpost=item.estciv;
        this.direccionpost=item.dir;
        this.idCole = item.idcol;
        this.cole = item.nomcol;
        this.egresopost = item.egreso;
        this.idPais = item.naci;
        this.paispost = item.pa;
        this.id_postexp = item.idexppos
        this.postexp = item.codciu;
        this.idCiudad = item.idciu;
        this.ciudad= item.ciudadnace;
        this.elModal = false;
        this.fechaReporte();
        this.listarDocumentoPendiente();
        this.limpiar();
        this.listartipopost();
        this.datosKardex=[];
        this.datosHorario=[];
        this.datosFranjaHoraria= [];
        
       
        //this.establecerMateriaRecursada(this.unicodigo);
      },
      async listarDocumentoPendiente(unicodigo) {
        let me = this;
        await axios
          .get("/estudiante/buscadepen/" + this.unicodigo)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosDocumentosPendientes = [];
              me.verificarTipoGrupo();
            } else {
              me.datosDocumentosPendientes = response.data.resultado;
              me.verificarDocumentos();
            }
          })
          .catch(function (error) {});
      },
      seleccionarGrupo(item) {
  
        if (this.cantidadMaximaMaterias > this.cantidadActualMaterias) {
      
          this.idGrupoDocente = item.idgr;
          this.idTipoModalidad = item.idmod;
          this.modalidad = item.modalidad;
          this.paraleloTeorico = item.gru;
          this.capacidad = item.cup;
          this.tipoGrupo = item.tpgru;
          this.idNivel = item.idnv;
          this.cantAct = item.cantact;
          this.idGrupoPadre = item.idgppadre;
          this.esCompartido = item.tipogr;
          this.idMateria = item.idmat;
          this.detalleModal = false;
     
          this.listarFechaInscripcion();
        } else {
       
          this.snackbarError7 = true;
    
        }
      },
  
      verificarTipoGrupo() {
        if (this.esCompartido === "COMPARTIDO") {
          this.verificarGrupoCompartido();
        } else {
          this.verificarGrupoPrivado();
        }
      },
      verificarGrupoCompartido() {
        this.listarHorarioGrupoCompartido(this.idGrupoPadre);
      },
      verificarGrupoPrivado() {
        this.listarHorarioGrupoPrivado(this.idGrupoDocente);
      },
      verificado() {
        this.verificarEspacio();
  
        //this.verificarExisteMateriaPractica();
      },
      espacioVerificado() {
        if (
          this.capacidad > this.datosCantidadEspacio[0].cnt &&
          this.capacidad != 0
        ) {
          this.inscribir();
          //this.datosCantidadEspacio = [];
        } else {
          this.snackbarError2 = true;
          //this.datosCantidadEspacio = [];
        }
      },
      inscribir() {
        if (this.yaInscrito == false) {
          this.verificarInscripcion();
          this.verificarPreinscipcionNota();
          this.yaInscrito = true;
        } else {
          this.verificarPreinscipcionNota();
        }
      },
  
      compararHorarios() {
        this.choquecant = 0;
        this.choqueHorario = 0;
  
        for (let i = 0; i < this.datosHorariosGrupo.length; i++) {
          for (let j = 0; j < this.datosHorario.length; j++) {
            if (
              this.datosHorario[j].iddi == this.datosHorariosGrupo[i].iddi &&
              this.datosHorario[j].idfranja == this.datosHorariosGrupo[i].idfh
            ) {
              this.choqueHorario = 1;
              this.choquecant = this.choquecant + this.choqueHorario;
            } else {
              this.choqueHorario = 0;
              this.choquecant = this.choquecant + this.choqueHorario;
            }
          }
        }
        //for
  
        if (this.choquecant == 0) {
          this.verificado();
        } else {
          this.snackbarError1 = true;
          //this.mensajeSnackbarHorario ;
        }
      },
  
      seleccionarGrupoPractico(item) {
        this.idGrupoDocente = item.idgr;
        this.idTipoModalidad = item.idmod;
        this.modalidad = item.modalidad;
        this.paralelo = item.gru;
        this.capacidad = item.capac;
        this.tipoGrupo = item.tpgrup;
        this.idNivel = item.idniv;
        this.gruposPracticosModal = false;
        this.verificarPreinscipcionNotaPractica();
      },
      seleccionarCarrera(item) {
        this.sumatoriaNotasFinales=0;
          this.materiasTomadas=0;
          this.materiasAprobadas=0;
          this.materiasReprobadas=0;
          this.promedioMateriasAprobadas=0;
          this.totalHorasAcademicasVencidas=0;
        this.carrera = item.carre;
        this.idCarrera = item.idcar;
        this.idPlanestudio = item.idplan;
        this.carreraModal = false;
        this.listarKardex(this.unicodigo, this.idPlanestudio);
        this.listarHistorialEconomico(this.unicodigo,this.id_sede);
        this.listarHistorialEconomicobservaciones(this.unicodigo,this.id_sede,this.idPlanestudio);
  
        this.listarObservacionGestion();
        this.listarTotalesHistorial();
      },
      seleccionarGestion(item) {
        this.sumatoriaNotasFinales=0;
        this.materiasTomadas=0;
        this.materiasAprobadas=0;
        this.materiasReprobadas=0;
        this.promedioMateriasAprobadas=0;
        this.totalHorasAcademicasVencidas=0;
        this.gestion = item.nom;
        this.idGestion = item.id_gestion;
        this.gestionModal = false;
        
        //this.listarCantidadMateriasPreinsEstu(this.unicodigo, this.idGestion);
        
        this.listarHorario(this.unicodigo, this.idGestion, this.idPlanestudio);
        this.listarFranjaHoraria(this.unicodigo);
      },
      seleccionarTurno(item) {
        this.turno = item.turno;
        this.idTurno = item.idturno;
        this.turnoModal = false;
  
        
       
      },
      showBuscarEstudiante() {
        //this.limpiar();
        this.elModal = true;
      },
     
      closeHorario() {
        this.horarioModal = false;
      },
      showDocumento() {
        //this.listarDocumento(this.unicodigo);
        this.documentosModal = true;
      },
      closeDocumento() {
        this.documentosModal = false;
      },
      showCarrera() {
        // this.limpiar();
        this.carreraModal = true;
        this.listarCarrera(this.unicodigo);
      },
      closeCarrera() {
        this.carreraModal = false;
      },
      showGestion() {
        //this.limpiar();
        this.gestionModal = true;
        this.listarGestion();
      },
      closeGestion() {
        this.gestionModal = false;
      },
      showTurno() {
        //this.limpiar();
        this.turnoModal = true;
        this.listarTurno();
      },
      closeTurno() {
        this.turnoModal = false;
      },
  
      showDetalleInscripcion(item) {
        this.detalleModal = true;
        this.idMateria = item.idmat;
  
        this.listarGruposInscripcion(
          this.idMateria,
          this.idTurno,
          this.idGestion
        );
      },
      closeDetalleInscripcion() {
        this.detalleModal = false;
      },
      showGruposPractica() {
        this.gruposPracticosModal = true;
        //this.idMateria = item.idmat;
        this.listarGruposInscripcionPractica(
          this.idMateria,
          this.idTurno,
          this.idGestion
        );
        //this.tienePractico = 'FALSE';
      },
      closeGruposPractica() {
        this.gruposPracticosModal = false;
      },
  
      limpiar() {
        //this.id_docente="";
        //this.tipodocente="";
        this.carrera = "";
        this.idCarrera = "";
        this.gestion = "";
        (this.idGestion = ""), (this.turno = "");
        this.idTurno = "";
        this.limpiarTotales();
      },
  
      addMateriaInscripcion() {
        this.añadirMateriaInscripcion(
          this.unicodigo,
          this.id_sede,
          this.idUsuario,
          this.idTurno,
          this.idCarrera,
          this.idGestion,
          this.idPlanEconomico
        );
        this.botonAct = 0;
      },
      async añadirMateriaInscripcion(
        unicodigo,
        id_sede,
        idUsuario,
        idTurno,
        idCarrera,
        idGestion,
        idPlanEconomico
      ) {
        let me = this;
  
        //let me=this;
        await axios
          .post(
            "/estudiante/addMateriaInscripcion/" +
              this.unicodigo +
              "," +
              this.id_sede +
              "," +
              this.idUsuario +
              "," +
              this.idTurno +
              "," +
              this.idCarrera +
              "," +
              this.idGestion +
              "," +
              this.idPlanEconomico
          )
          .then(function (response) {
            me.snackbarOK = true;
            me.mensajeSnackbar = response.data.message;
  
            me.listarHorario(me.unicodigo, me.idGestion, me.idPlanestudio);
  
            me.listarFranjaHoraria(me.unicodigo);
  
            //me.cantidadActualMaterias++;
          })
          .catch(function (error) {
            me.snackbarError = true;
            me.mensajeSnackbar = response.data.message;
          });
      },
      async establecerMateriaRecursada(unicodigo, idMateria) {
        let me = this;
        await axios
          .post(
            "/estudiante/establecermateriarecur/" +
              this.unicodigo +
              "," +
              this.idMateria
          )
          .then(function (response) {})
          .catch(function (error) {});
      },
      verificarPreinscipcionNota() {
        this.verificarRecursada(this.unicodigo, this.idMateria, this.idGestion);
        this.verificarpre(this.idGrupoDocente, this.unicodigo, this.idMateria);
      },
      async verificarpre(idGrupoDocente, unicodigo, idMateria) {
        let me = this;
        await axios
          .get(
            "/estudiante/verificarpreinscrito/" +
              this.idGrupoDocente +
              "," +
              this.unicodigo +
              "," +
              this.idMateria
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.idGrupoAux = me.idGrupoDocente;
              me.verificarExsiteMatPractica();
              // me.addMateriaInscripcionNota();
            } else {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            }
          })
          .catch(function (error) {});
      },
      async verificarRecursada(unicodigo, idMateria, idGestion) {
        let me = this;
        await axios
          .get(
            "/estudiante/verificarRecursada/" +
              this.unicodigo +
              "," +
              this.idMateria +
              "," +
              this.idGestion
          )
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosRecursado = false;
            } else {
              me.datosRecursado = true;
            }
          })
          .catch(function (error) {});
      },
      verificarEspacio() {
        this.listarCantActualInscr(this.idGrupoDocente);
      },
      async listarCantActualInscr(idGrupoDocente) {
        let me = this;
        await axios
          .get("/estudiante/verificarEspacio/" + this.idGrupoDocente)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosCantidadEspacio = [];
            } else {
              me.datosCantidadEspacio = response.data.resultado;
  
              me.espacioVerificado();
            }
          })
          .catch(function (error) {});
      },
      /* verificarExisteMateriaPractica() {
     
         this.verificarExsiteMatPractica(this.idPlanestudio, this.idGestion, this.idMateria);
     
       },*/
      
      verificarHorario() {
        this.verificarhorario(this.idFranjaHoraria, this.unicodigo, this.idDia);
      },
      async verificarhorario(idFranjaHoraria, unicodigo, idDia) {
        let me = this;
        await axios
          .get(
            "/estudiante/verificarhorario/" +
              this.idFranjaHoraria +
              "," +
              this.unicodigo +
              "," +
              this.idDia
          )
          .then(function (response) {
            if (response.data.resultado == null) {
            } else {
              me.snackbarError = true;
              me.mensajeSnackbar = response.data.message;
            }
          })
          .catch(function (error) {
            me.snackbarError = true;
            me.mensajeSnackbar = response.data.message;
          });
      },
      
      
     
      
      
     
  
      deleteItem(item) {
        this.editedIndex = item.nitf;
        this.editedItem = item.nitf;
        // this.dialogDelete = true
      },
  
      close() {
        this.elModal = false;
      },
      showCompromiso() {
        this.compromisoModal = true;
      },
      closeCompromiso() {
        this.compromisoModal = false;
      },
      showKardex() {
        this.kardexModal = true;
      },
      closeKardex() {
        this.kardexModal = false;
      },
      showRegcompromiso(item) {
        this.iddocseg1 = item.iddocseg;
        this.documento1 = item.documento;
        this.regcompromisoModal = true;
      },
      closeRegcompromiso() {
        this.regcompromisoModal = false;
      },
      realizarcompromiso() {
        this.regcompromisoModal = false;
        this.registrarcompromisodoc(this.iddocseg1, this.fplazo);
  
        // this.registrarcobrodetalle(this.id_docente)
      },
      showSede() {
              this.listarsede();
              this.sedeModal = true;
              //this.listarpostexp(this.id_pais)
          },
          closeSede() {
              this.sedeModal = false;
          },
          seleccionarSede(item) {
              this.id_sede = item.idsd;
              this.sede1 = item.sede;
              this.sedeModal = false;
              this.listarPlanEstudio(this.id_sede);
              //this.listarTipoFactura();
              //this.listarParametrosPagos();
          },
          // DATOS TIPO DE ESTUDIANTE
          showTpostulante() {
      this.tpostModal = true;
    },
    closeTpost() {
      this.tpostModal = false;
    },
    seleccionarTpost(item) {
      this.id_tpost = item.idestcat;
      this.tpost = item.categoria;
      this.tpostModal = false;
      if (this.id_tpost == 4) {
        this.nacionalidadpost = "EXTRANJERO";
      } else {
        this.nacionalidadpost = "BOLIVIANA";
      }
    },
    async listartipopost() {
      let me = this;
      await axios
        .get("/postulante/listarcat")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datostpost = [];
          } else {
            me.datostpost = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
          //**************************//
          // LUGAR DE EXPEDIDO //
          showPostexp() {
            this.postexpModal = true;
            this.listarpostexp(this.idPais);
            },
            closePostexp() {
            this.postexpModal = false;
            },
            seleccionarPostexp(item) {
            this.id_postexp = item.idciudad;
            this.postexp = item.ciudadabre;
            this.postexpModal = false;
            },
            async listarpostexp(idPais) {
            let me = this;
            await axios
                .get("/ciudades/listarpostexp/" + this.idPais)
                .then(function (response) {
                if (response.data.resultado == null) {
                    me.datospostexp = [];
                    
                } else {
                    me.datospostexp = response.data.resultado;
                }
                })
                .catch(function (error) {});
            },
          //**************************//
          ///**************************
          // COLEGIOS
          showColegio() {     
                
                this.listarColegio();      
                this.colegioModal = true;
            },
            closeColegio() {
                this.colegioModal = false;
            },
            seleccionarColegio(item) {
                this.idCole = item.idcol;
                this.cole = item.cole;
                this.colegioModal = false;
            },
            listarColegio() {
            this.listarColegios(this.id_sede);
            },
            async listarColegios(id_sede) {
            let me = this;
            await axios
                .get("/crm/listarcolegiostodos/" + this.id_sede)
                .then(function (response) {
                if (response.data.resultado == null) {
                    me.datosColegio = [];
                } else {
                    me.datosColegio = response.data.resultado;
                }
                })
                .catch(function (error) {});
            },
            //******************************
            // AÑO DE EGRESO
                showEgreso() {
                this.listaregreso();
                this.egresoModal = true;
                },
                closeEgreso() {
                this.egresoModal = false;
                },
                seleccionarEgreso(item) {
                this.egresopost = item.anoegreso;
                this.egresoModal = false;
                },
                async listaregreso() {
                let me = this;
                await axios
                    .get("/postulante/listaranoegreso")
                    .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datosegreso = [];
                    } else {
                        me.datosegreso = response.data.resultado;
                    }
                    })
                    .catch(function (error) {});
                },
    //***************************************
    // MATRICULA
    actualizarmatricula(){
        this.verificarplanmatricula();
    },
    verificarplanmatricula(){
            let me = this;
           if(this.idPlanestudio ==""){
            me.mensajeSnackbar = "USTED DEBE SELECCIONAR EL PLAN DE ESTUDIOS :(";
            me.snackbarOK = true;
           } 
           else {
           this.actualizarDatosmatricula(); 
           }
        },
        async actualizarDatosmatricula() {
        if (this.checkboxExppost === true) {
        this.id_postexp = 13;
      }
      let me = this;
      await axios
        .post(
          "/estudiante/updatematriculanew/"+this.unicodigo +","+
            this.id_sede +            
            "," +
            this.idPlanestudio 
        )
        .then(function (response) {
         
          me.mensajeSnackbar = response.data.message;
          me.snackbarOK = true;
          me.mostrarmatricula();
          //me.listarDatos();
        })
  
        .catch(function (error) {
          me.snackbarError = true;
         
        });
    },
    async mostrarmatricula() {
        
      let me = this;
      await axios
        .get("/estudiante/listarnuevamatricula/" + this.unicodigo)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosnuevamatricula= [];
  
          } else {
            me.datosnuevamatricula = response.data.resultado;
            me.matricula = me.datosnuevamatricula[0].matri;
          }
        })
        .catch(function (error) {});
    },
    //***************************************
    //****************************************
    // PAIS Y CUIDAD 
    actualizardtestudiante(){
  
        this.nuevadireccionpost = this.direccionpost.replaceAll("/", ".");
       // this.nuevaObservacion=this.observacion.replaceAll("/", ".");
          this.verificarplan();
  
        },
        verificarplan(){
            let me = this;
           if(this.idPlanestudio ==""){
            me.mensajeSnackbar = "USTED DEBE SELECCIONAR EL PLAN DE ESTUDIOS :(";
            me.snackbarOK = true;
           } 
           else {
           this.actualizarDatos(); 
           }
        },
    async actualizarDatos() {
        if (this.checkboxExppost === true) {
        this.id_postexp = 13;
      }
      let me = this;
      await axios
        .post(
          "/estudiante/actualizarDatosEst/"+this.unicodigo +","+
            this.id_tpost +            
            "," +
            this.nombres +
            "," +
            this.paterno +
            "," +
            this.materno+            
            "," +
            this.idPais+            
            "," +
            this.idCiudad +            
            "," +
            this.tipodocpost +            
            "," +
            this.documento +            
            "," +
            this.id_postexp +            
            "," +
            this.generopost +            
            "," +
            this.fechanacipost +            
            "," +
            this.estadocivpost +            
            "," +
            this.nuevadireccionpost +            
            "," +
            this.emailpost +            
            "," +
            this.telefonopost +            
            "," +
            this.idCole +            
            "," +
            this.egresopost+            
            "," +
            this.idPlanestudio 
        )
        .then(function (response) {
         
          me.mensajeSnackbar = response.data.message;
          me.snackbarOK = true;
          //me.listarDatos();
        })
  
        .catch(function (error) {
          me.snackbarError = true;
         
        });
    },
    showPais() {
      this.paisModal = true;
      this.listarpaises();
    },
    closePais() {
      this.paisModal = false;
    },
    seleccionarPais(item) {
      this.idPais = item.idpais;
      this.paispost = item.pais;
      this.paisModal = false;
    },
  
    showCiudad() {
      this.ciudadModal = true;
      this.listarCiudades();
    },
  
    seleccionarCiudad(item) {
      this.idCiudad = item.idciudad;
      this.ciudad = item.ciudad;
      this.ciudadModal = false;
    },
    async listarpaises() {
      let me = this;
      await axios
        .get("/paises/listarpaises")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datospais = [];
          } else {
            me.datospais = response.data.resultado;
          }
        })
        .catch(function (error) {});
    }, 
    async listarCiudades() {
      let me = this;
      await axios
        .get("/ciudades/listarciudades")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosciudad= [];
          } else {
            me.datosciudad = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
    //*****************************************
          async listarsede() {
              let me = this;
              await axios
                  .get("/reporte/sedes")
                  .then(function (response) {
                      if (response.data.resultado == null) {
                          me.datossede = [];
                          me.alertsede = {
                              show: true,
                              type: "error",
                              message: "NO EXISTEN DATOS:(",
                          };
                      } else {
                          //console.log(response.data);
                          me.datossede = response.data.resultado;
                          me.alertsede = { show: false, type: "", message: "" };
                      }
                  })
                  .catch(function (error) {
                      console.log(error);
                  });
          },
    },
  };
  </script>
  <style>
  
  .header { width: 100%; height: 50px; text-align: center; background-color: #f0f0f0; border-bottom: 1px solid #ddd; padding: 50px 0;z-index: 1000; } 
  .page-break { page-break-before: always; margin-top: 70px; /* Ajusta el espacio de la cabecera */ }
  </style>  